// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { useLocalMessage } from '@Helpers/';
import Details from '@Molecules/Details/Details';
import { extractData } from '@Organisms/Organisation/extractData';
import { OrganisationOutput } from 'thehive-sdk';
import { OrganisationEventList } from '@Organisms/Organisation/eventList';

import './OrgLayoutSider.scss';

interface OrgLayoutSiderProps {
    data: OrganisationOutput;
    eventList: OrganisationEventList;
    orgId: string;
    hasPermissions?: boolean;
}

const OrgLayoutSider = ({ data, eventList, orgId, hasPermissions }: OrgLayoutSiderProps): ReactElement => (
    <div className="org-layout-sider">
        <Details
            data={{
                ...data,
                '#computeSharingRule': {
                    observableRule: data.observableRule,
                    taskRule: data.taskRule,
                },
            }}
            extract={extractData({ locale: useLocalMessage(), eventList, orgId, hasPermissions })}
            className="organisation-details"
        />
    </div>
);

export default OrgLayoutSider;
